"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textProps = void 0;
// Size 'xs' needed to use 'caption' for all the text elements since
// 'as' title and paragraph are not available in those sizes.

const textProps = exports.textProps = {
  '2xl': {
    eyebrow: {
      size: 2,
      as: 'caption'
    },
    title: {
      size: 0,
      as: 'heading'
    },
    paragraph: {
      size: 3,
      as: 'paragraph'
    }
  },
  'xl': {
    eyebrow: {
      size: 1,
      as: 'caption'
    },
    title: {
      size: 3,
      as: 'title'
    },
    paragraph: {
      size: 1,
      as: 'paragraph'
    }
  },
  'lg': {
    eyebrow: {
      size: 0,
      as: 'caption'
    },
    title: {
      size: 1,
      as: 'title'
    },
    paragraph: {
      size: 0,
      as: 'paragraph'
    }
  },
  'md': {
    eyebrow: {
      size: 0,
      as: 'caption'
    },
    title: {
      size: 0,
      as: 'title'
    },
    paragraph: {
      size: 0,
      as: 'paragraph'
    }
  },
  'sm': {
    eyebrow: {
      size: -1,
      as: 'caption'
    },
    title: {
      size: -2,
      as: 'title'
    },
    paragraph: {
      size: -1,
      as: 'paragraph'
    }
  },
  'xs': {
    eyebrow: {
      size: -2,
      as: 'caption'
    },
    title: {
      size: 0,
      as: 'caption'
    },
    paragraph: {
      size: -1,
      as: 'caption'
    }
  }
};